import {
    useState, useEffect
} from 'react';
import {
    Grid, List, LayoutGrid
} from 'lucide-react';
import {
    useRouting
} from './RoutingContext';
import {
    Tabs, TabsContent, TabsList, TabsTrigger
} from 'shared/components/ui/tabs';
import {
    useParams
} from 'react-router-dom';
import {
    TableFields
} from './table-fields/Fields';
import {
    TableRules
} from './TableRules';
import {
    RecordsTable
} from './table-records/RecordsTable';

function formatTableName(tableName) {
    return tableName
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z]+)(?=[A-Z][a-z])/g, '$1 ')
        .replace(/([A-Z]+)(?=[A-Z]+$)/g, '$1')
        .replace(/^./, (str) => str.toUpperCase())
        .replace(/\s+/g, ' ');
}

export function TableViewSelector() {
    const {
        tableId
    } = useParams();
    const {
        tables
    } = useRouting();

    // Initialize tableName with the current table name
    const [tableName, setTableName] = useState(() => {
        const table = tables.find((table) => table.id === tableId);
        return table ? formatTableName(table.name) : 'Untitled Table';
    });

    // Update tableName when tableId changes
    useEffect(() => {
        const table = tables.find((table) => table.id === tableId);
        setTableName(table ? formatTableName(table.name) : 'Untitled Table');
    }, [tableId, tables]);

    const views = [
        {
            id: 'records',
            name: 'Records',
            icon: Grid
        },
        {
            id: 'fields',
            name: 'Fields',
            icon: LayoutGrid
        },
        {
            id: 'rules',
            name: 'Rules',
            icon: List
        },
    ];

    return (
        <div className="flex flex-col w-full h-[100%] bg-white px-4 pt-2 pb-10">
            <div className="flex items-center my-4 h-8">
                <h2 className="text-xl font-semibold">{tableName}</h2>
            </div>
            <div className="flex flex-grow w-full h-full">
                <Tabs defaultValue="records" className="flex flex-col h-full w-full">
                    <TabsList className="flex item-senter h-10 w-fit ">
                        {views.map((view) => {
                            const Icon = view.icon;
                            return (
                                <TabsTrigger
                                    key={view.id}
                                    value={view.id}
                                    className="flex items-center gap-2"
                                >
                                    <Icon className="h-4 w-4" />
                                    {view.name}
                                </TabsTrigger>
                            );
                        })}
                    </TabsList>
                    <TabsContent className="flex-grow h-0" value="records">
                        <RecordsTable tableId={tableId} viewId="grid" />
                    </TabsContent>
                    <TabsContent className="flex-grow h-0" value="fields">
                        <TableFields tableId={tableId} />
                    </TabsContent>
                    <TabsContent className="flex-grow h-0" value="rules">
                        <TableRules />
                    </TabsContent>
                </Tabs>
            </div>
        </div>
    );
}